import CategoryCard, {
  type ICategoryCard,
} from 'features/rewards/components/CategoryCard/CategoryCard';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import SectionDivider from 'shared/components/vxl/divider/SectionDivider/SectionDivider';
import theme from 'shared/styles/theme';

interface CategoryGridProps {
  categories: ICategoryCard[];
  onPressViewAll: () => void;
}

const CategoryGrid = ({ categories, onPressViewAll }: CategoryGridProps) => {
  const displayedCategories = categories.slice(0, 5);

  displayedCategories.push({
    label: 'View all categories',
    iconKey: 'ARROW_RIGHT',
    analyticsId: 'viewAllCategoriesClicked',
    customAttributes: {
      source_name: 'rewards_page',
      category: 'rewards',
    },
    onPress: () => {
      onPressViewAll();
    },
    isDisabled: false,
  });

  return (
    <View style={styles.container}>
      <SectionDivider
        labelText="Categories"
        background="none"
        textSize="large"
      />
      <View style={styles.categoryContainer}>
        {displayedCategories.map((category) => (
          <CategoryCard {...category} key={category.label} />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.tertiary,
  },
  categoryContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: theme.spacing.s,
    marginHorizontal: theme.spacing.m,
    marginTop: theme.spacing.m,
    marginBottom: theme.spacing.m,
  },
});

export default CategoryGrid;
